import React from "react";
import { Typography, Box } from "@mui/material";
import Carousel from "./Carousel";
import CardCorporative from "./Corporative";
import Accordion from "./AccordionHome";
import "../Styles/Home.css";
import TranslatedText from "./TranslatedText";

const Home = () => {
  return (
    <>
      <Box component="main" sx={{ p: 3, width: "100vw" }}>
        <CardCorporative /> {/*component*/}
        <div className="home-text">
          <Typography
            variant="h3"
            sx={{
              fontSize: 26,
              textAlign: "center",
              "@media screen and (max-width: 690px)": { fontSize: "22px" },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="ЗАВДАННЯ" />
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="Надати інформаційну підтримку українським біженцям" />
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
          >
            <TranslatedText defaultText=" Допомогти їм інтегруватися в норвезьке суспільство" />
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: 26,
              textAlign: "center",
              marginTop: "5vh",
              "@media screen and (max-width: 690px)": { fontSize: "22px" },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="МЕТА" />
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
          >
            <TranslatedText defaultText="Забезпечити біженцям необхідну інформацію та підтримку для успішної інтеграції в нове середовище" />
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
          >
            <TranslatedText defaultText="Створити умови для формування позитивного сприйняття українських біженців у норвезькому суспільстві" />
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: 26,
              textAlign: "center",
              marginTop: "5vh",
              "@media screen and (max-width: 690px)": { fontSize: "22px" },
            }}
            gutterBottom
          >
            <TranslatedText defaultText="ОЧІКУВАНИЙ РЕЗУЛЬТАТ" />
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
          >
            <TranslatedText defaultText="Зменшення культурного шоку та соціальної віддаленості українських біженців від норвезького суспільства" />
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: 23,
              fontWeight: "380",
              "@media screen and (max-width: 690px)": { fontSize: "18px" },
            }}
          >
            <TranslatedText defaultText="Створення можливостей для біженців у реалізації їхнього потенціалу в новому середовищі" />
          </Typography>
        </div>
        <Box className="carousel">
          <Carousel />
          <Accordion />
        </Box>
      </Box>
    </>
  );
};

export default Home;
